import React from "react";
import { CalendarClock } from "lucide-react";

const fmtDay = (d) => d.toLocaleDateString(undefined, { day: "numeric", month: "long" });

// Context-aware return: a dated anchor is approaching and related prep is still open.
export const AnchorGroupCard = ({ card, onOpen, onNotNow }) => {
  if (!card || !card.dependents || !card.dependents.length) return null;
  const { anchor, dependents, date } = card;
  return (
    <div
      data-testid={`anchor-group-card-${anchor.id}`}
      className="mb-8 rounded-2xl bg-[var(--surface)] border border-[var(--line)] p-5 md:p-6"
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="text-[var(--pine)]"><CalendarClock size={16} strokeWidth={1.9} /></span>
        <h2 className="font-heading font-medium text-[var(--ink)] text-base">
          Coming up — {anchor.interpreted_summary}, {fmtDay(date)}
        </h2>
      </div>
      <p className="text-sm text-[var(--ink3)] mb-4">A couple of related things are still open. No rush — here when you want it.</p>

      <div className="space-y-3">
        {dependents.map((d) => (
          <div
            key={d.id}
            data-testid={`anchor-group-item-${d.id}`}
            className="flex items-start justify-between gap-3 rounded-xl bg-[var(--surface2)] border border-[var(--line)] px-3.5 py-3"
          >
            <p className="text-[var(--ink)] font-medium truncate">
              {d.interpreted_summary} <span className="text-[var(--ink5)] font-normal">— still open</span>
            </p>
            <button
              data-testid={`anchor-group-open-${d.id}`}
              onClick={() => onOpen(d.id)}
              className="shrink-0 rounded-full bg-[var(--pine)] hover:bg-[var(--pine-dark)] text-[var(--on-pine)] text-[13px] font-medium px-3.5 py-1.5 transition-colors"
            >
              Open
            </button>
          </div>
        ))}
      </div>

      <button
        data-testid={`anchor-group-snooze-${anchor.id}`}
        onClick={() => onNotNow(anchor)}
        className="mt-4 rounded-full border border-[var(--line)] hover:bg-[var(--surface2)] text-[var(--ink3)] text-[13px] font-medium px-3.5 py-1.5 transition-colors"
      >
        Not now
      </button>
    </div>
  );
};
